import {Component, inject, input, output} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {ProductPackageData} from "../../types/product-package-modal.types";
import {ProductCardFormFieldService} from "../../../../../services/product-card-form-field.service";
import {ModalsService} from "../../../../../../../../core/services/modals.service";

@Component({
  selector: 'app-product-package-accordion-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './product-package-accordion-title.component.html',
  styleUrl: './product-package-accordion-title.component.scss'
})
export class ProductPackageAccordionTitleComponent {
  productPackage = input.required<ProductPackageData>();
  isEditModeActive = input<boolean>(false);
  deleteRecord = output<number>();

  private productCardFormFieldService: ProductCardFormFieldService = inject(ProductCardFormFieldService);
  private modalService: ModalsService = inject(ModalsService);

  public getSizeParams(): string {
    return `${this.productPackage().length || 0}x${this.productPackage().width || 0}x${this.productPackage().height || 0}`;
  }

  public getSWightQuantityParams(): string {
    return `${this.productPackage().weight || 0}кг - ${this.productPackage().quantity || 0}шт`;
  }

  public async handleBtnClick(event: MouseEvent, key: string): Promise<void> {
    event.stopPropagation();
    const handle: Record<string, ()  => Promise<void>> = {
      history: () => this.handleOpenHistoryModal(),
      delete: () => this.handleDelete()
    }

    await handle[key]?.();
  }

  private async handleOpenHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.productPackage().history || [],
      columnKey: 'productPackages'
    });
  }

  private async handleDelete(): Promise<void> {
    const id = this.productPackage().id;
    const isConfirmed = await this.productCardFormFieldService.isDeleteConfirmed(id);
    if (!isConfirmed) { return; }

    this.deleteRecord.emit(id);
  }
}
